"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityPopupHost = void 0;
var react_1 = __importDefault(require("react"));
var BusinessImpactPopup_1 = require("./BusinessImpactPopup");
var MetricPopup_1 = require("./MetricPopup");
var PersonaPopup_1 = require("./PersonaPopup");
var TechnologyPopup_1 = require("./TechnologyPopup");
var element_popup_adapter_1 = require("./services/element-popup.adapter");
var element_popup_service_1 = require("./services/element-popup.service");
/**
 * Convenience wrapper that picks the right popup component for a
 * kind and feeds it real backend data. There is no mock fallback —
 * if the catalogue has no row for `elementId`, the popup does not
 * render. Parents should suppress the trigger UI for terms that are
 * not yet in the catalogue.
 */
exports.EntityPopupHost = function (_a) {
    var kind = _a.kind, isOpen = _a.isOpen, onDismiss = _a.onDismiss, elementId = _a.elementId, useCaseId = _a.useCaseId;
    var _b = react_1.default.useState(null), response = _b[0], setResponse = _b[1];
    react_1.default.useEffect(function () {
        var cancelled = false;
        if (!isOpen || !elementId) {
            setResponse(null);
            return function () {
                cancelled = true;
            };
        }
        element_popup_service_1.fetchElementPopup(elementId, useCaseId)
            .then(function (data) {
            if (!cancelled)
                setResponse(data);
        })
            .catch(function () {
            if (!cancelled)
                setResponse(null);
        });
        return function () {
            cancelled = true;
        };
    }, [isOpen, elementId, useCaseId]);
    if (!isOpen || !response) {
        return null;
    }
    if (kind === 'business-impact') {
        return (react_1.default.createElement(BusinessImpactPopup_1.BusinessImpactPopup, { isOpen: isOpen, onDismiss: onDismiss, content: element_popup_adapter_1.adaptToBusinessImpact(response, useCaseId) }));
    }
    if (kind === 'persona') {
        return (react_1.default.createElement(PersonaPopup_1.PersonaPopup, { isOpen: isOpen, onDismiss: onDismiss, content: element_popup_adapter_1.adaptToPersona(response, useCaseId) }));
    }
    if (kind === 'metric') {
        return (react_1.default.createElement(MetricPopup_1.MetricPopup, { isOpen: isOpen, onDismiss: onDismiss, content: element_popup_adapter_1.adaptToMetric(response, useCaseId) }));
    }
    if (kind === 'technology') {
        return (react_1.default.createElement(TechnologyPopup_1.TechnologyPopup, { isOpen: isOpen, onDismiss: onDismiss, content: element_popup_adapter_1.adaptToTechnology(response, useCaseId) }));
    }
    return null;
};
